
$(window).on('load',function(e){
  $(document).on('mouseenter','.add_to_cart_swatch .ctm_trigger_btn',function(e){
    $(this).closest('form').find('.add_to_cart_swatch .ctm_trigger_btn input').trigger('click');
  });
  
  $('.ctm_color .swatch-element:first-child').each(function(e){
    var val = $(this).find(':radio').val();
    if($(this).closest('form').find('.ctm_images[data-alt="'+val+'"]').length > 1){
      var _this = $(this)
      $(this).closest('form').find('.ctm_images[data-alt="'+val+'"]').each(function(i,e){
        var img = $(this).data('img');
        console.log(i)
        if(i == 0){
          _this.closest('form').find('.rimage-wrapper .rimage__image').attr('srcset',img);
        }
        if(i == 1){
          _this.closest('form').find('.hover_images .secondary-image').css('background-image','url("'+img+'")');
        }
        console.log(img)
      })
    }
    $(this).closest('.ctm_colors').find('.color_names [data-color]').text(val);
  })
});

$(document).on('click','.add_to_cart_swatch .ctm_trigger_btn input',function(e){
  $(this).closest('.add_to_cart_swatch').addClass('active_size')
});

$(document).on('click','.trigger_notify_me',function(e){
  $(this).closest('form').find('.notify_me_btn a')[0].click();
});

$(document).on('mouseenter','.ctm__form_text',function(e){
  $(this).find('.active_size').removeClass('active_size')
  $(this).closest('form').find('.notify_me_btn').hide();
  $(this).closest('.ctm__form_text').find('.ctm_trigger_btn').show();
})
$(document).on('mouseleave','.ctm__form_text',function(e){
  $(this).find('.active_size').removeClass('active_size')
});